import * as z from "zod";

/** Deletes an automation that has never been published; a published one is turned off instead. */
export const deleteAutomation = {
  name: "deleteAutomation" as const,
  input: z.object({ id: z.string() }),
  output: z.object({}),
};
